import React, { useState } from "react";
import toast from "react-hot-toast";
import HomeService from "../../../Services/HomeService";
import { useNavigate } from "react-router-dom";

const headLineStyle = {
    textAlign: "center",
    fontSize: "30px",
    color: "#868e96",
    margin: "15px",
    fontWeight: "bold",
};

function AddJobCategory() {

    const navigate = useNavigate();
    const initialValue = {
        catName: "",
        description: ""
    }
    const [formValue, setFormValue] = useState(initialValue)

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!formValue.catName) return toast.error("Category Name should not be empty!")
            console.log("GTR26",formValue);
            // return
        try {
            const res = await HomeService.addJobCategory(formValue);
            if (res?.status) {
                toast.success("Category added successfully!");
                setFormValue(initialValue)
                navigate("/manage-job-category");
            }
        } catch (error) {
            toast.error("Failed to add Category.");
            console.error("Error adding Category:", error);
        }
    };

    return (
        <div className="main_wrap" style={{ marginTop: "6rem" }}>
            <div className="container-fluid">
                <div className="mt-5">
                    <div style={headLineStyle} className="page-headline">
                        Add Job Category
                    </div>
                    <hr />

                    <section className="chartBox_area">
                        <form onSubmit={handleSubmit}>
                            <div className="row">
                                <div className="col-md-12 mt-3">
                                    <label>
                                        Category Name<span className="text-danger">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        name="catName"
                                        className="form-control"
                                        value={formValue.catName}
                                        onChange={(e) => setFormValue({ ...formValue, catName: e.target.value })}
                                        placeholder="Enter Category Name"
                                        required
                                    />
                                </div>
                                <div className="col-md-12 mt-3">
                                    <label>
                                        Description
                                    </label>

                                    <textarea
                                        className="form-control"
                                        name="description"
                                        value={formValue.description}
                                        onChange={(e) => setFormValue({ ...formValue, description: e.target.value })}
                                        placeholder="Enter description (if any)"
                                    ></textarea>
                                </div>
                            </div>
                            <button type="submit" style={{
                                background: 'rgb(133, 218, 79)',
                                borderRadius: '13px'
                            }} className="btn mt-3">
                                Add
                            </button>
                        </form>
                    </section>
                </div>
            </div>
        </div>
    );
}

export default AddJobCategory;
